import React from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

const EmbedListSortableTh = ({
    columnKey,
    label,
    sort,
    onSortChange,
    sortable = true,
    className = '',
    style = {},
}) => {
    const setSortIcon = () => {
        if (!sortable || sort.by !== columnKey) {
            return null;
        }
        return sort.direction === 'asc' ? <FaCaretUp /> : <FaCaretDown />;
    };

    const handleClick = () => {
        if (!sortable) {
            return;
        }
        onSortChange(columnKey);
    };

    return (
        <th
            className={`${sortable ? 'cursor-pointer' : ''} ${className}`.trim()}
            style={style}
            onClick={handleClick}
        >
            {label}
            {setSortIcon()}
        </th>
    );
};

export default EmbedListSortableTh;
